import axios from "utils/axios";

export const getThrProgressive = () => {
  return axios.get("/hr/thrProgressivePeriods");
};

export const editThrProgressive = (data) => {
  return axios.post("/hr/thrProgressivePeriods", data);
};
